// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"945":"965904f0","3212":"86040a39"}[chunkId] + ".chunk.css";
};